
import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import {
  NOT_AUTHORIZED_PATH,
  isNoRolesError
} from '../auth/no-roles.interceptor';
import { UserPermissionService } from '@services/user-permission.service';

export const hasRolesGuard: CanActivateChildFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const permissions = inject(UserPermissionService);

  if (!auth.isLoggedIn()) {
    return true;
  }

  const noRolesUrl = () =>
    router.createUrlTree([NOT_AUTHORIZED_PATH], {
      queryParams: { reason: 'no-roles' }
    });

  return permissions.load().pipe(
    map(user =>
      (user.roles?.length ?? 0) > 0 ? true : noRolesUrl()
    ),
    catchError((err: unknown) => {
      if (isNoRolesError(err)) {
        return of(noRolesUrl());
      }

      // Do not misclassify a temporary API failure as zero roles.
      console.error('Could not verify user roles', err);
      return of(false);
    })
  );
};


